import { ICON__fold_horizontal, ICON__unfold_horizontal } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';

interface PROPS {}

export function GRID2D_BUTTON__hide_sidebars({}: PROPS) {
  const dispatch = use_dispatch();
  /*
   *
   */
  const { global__hide_sidebars } = use_slice_ui(['global__hide_sidebars']);

  /*
   *
   */

  use_effect(() => {
    return () => void dispatch(LOCAL__ui_set_boolean({ key: 'global__hide_sidebars', value: false }));
  }, []);

  /*
   *
   */
  function onClick(event: React.MouseEvent<HTMLElement>): void {
    event.stopPropagation();

    dispatch(LOCAL__ui_set_boolean({ key: 'global__hide_sidebars', value: !global__hide_sidebars }));
  }

  /*
   *
   */

  return (
    <>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-bar'}
        Icon={global__hide_sidebars ? ICON__fold_horizontal : ICON__unfold_horizontal}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        {...{ onClick }}
        className="p-0 h-[28px] w-[30px] flex items-center justify-center"
        iconClassNameBase="!text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
      />
    </>
  );
}
